import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const links = [
    { label: 'Accueil', to: '/' },
    { label: 'À propos', to: '/a-propos' },
    { label: 'Contact', to: '/contact' },
  ];

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-stone-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/1286ceb3-1c4c-499f-bb53-de2e12d300c4.png"
              alt="KURTA logo"
              className="w-9 h-9 object-contain"
            />
          </div>
          <span
            className={`text-lg font-bold tracking-widest transition-colors duration-300 ${
              scrolled ? 'text-stone-900' : 'text-stone-900'
            }`}
          >
            KURTA
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap relative group ${
                isActive(link.to)
                  ? 'text-stone-900'
                  : 'text-stone-500 hover:text-stone-900'
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-px bg-stone-900 transition-all duration-300 ${
                  isActive(link.to) ? 'w-full' : 'w-0 group-hover:w-full'
                }`}
              />
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-4 px-5 py-2 text-sm font-medium bg-stone-900 text-white rounded-full hover:bg-stone-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Prendre contact
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-stone-900`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden bg-white border-t border-stone-100 overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-64' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-4">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-base font-medium py-2 cursor-pointer ${
                isActive(link.to) ? 'text-stone-900' : 'text-stone-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-5 py-3 text-sm font-medium bg-stone-900 text-white rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            Prendre contact
          </Link>
        </nav>
      </div>
    </header>
  );
}